<template>
  <div>
    <vs-popup
      class="holamundo"
      :title="$t('AddStockToShelf')"
      :active.sync="isSidebarActiveLocal"
      @close="closeShelfPopup"
      @cancel="closeShelfPopup"
      fullscreen
    >
      <AddStockToShelf :data="data" />
    </vs-popup>
  </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import i18nData from "../../i18n/i18nData";
import vSelect from "vue-select";
import { Icon } from "@iconify/vue2";
import { uuid } from "vue-uuid";
import { Validator } from "vee-validate";
import updateDeleBtnDynamic from "../CellRenderers/updateDeleteBtnDynamic.vue";
import AddStockToShelf from "./AddStockToShelf.vue";
export default {
  components: { uuid, Icon, vSelect, AgGridVue, updateDeleBtnDynamic, AddStockToShelf },
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      default: () => {},
    },
  },
  data() {
    return {
      allProductList: [],
      productCode: "",
      stock: "",
      customer: "",
      corridor: "",
      shelfCode: "",
      corridorCode: "",
      CorridorId: "",
      ShelfId: "",
      CompanyId: "",
      CompanyCode: "",
      quantity: 1,

      corridor_choices: [],
      stock_choices: [],

      shelf_choices: [],
      customer_choices: [],
      manualOperation: false,
      ROLE: this.$store.state.AppActiveUser.ROLE,

      shelf: [],
      shelfColumns: [],
      defaultColDef: {
        sortable: true,
        editable: true,
        resizable: true,
      },
      scanText: "PleaseCorridor",
    };
  },
  methods: {
    closeShelfPopup() {
      this.shelf = "";
      this.stock = "";
      this.customer = "";
      this.corridor = "";
      this.shelfCode = "";
      this.corridorCode = "";
      this.productCode = "";
      this.scanText = "PleaseCorridor";
      this.CorridorId = "";
      this.ShelfId = "";
      this.CompanyId = "";
      this.CompanyCode = "";
      this.isSidebarActiveLocal = false;
    },
  },
  mounted() {},
  beforeDestroy() {},
  created() {
		
  },
  watch: {
    companydata(val) {
      return val;
    },
    data(val) {
      return val;
    },
    isSidebarActive(val) {
      if (val == true) {
        setTimeout(() => {
          document.getElementById("corridorCode").focus();
        }, 50);
      }
      return val;
    },
  },
  computed: {
    companydata: {
      get() {
        return this.$store.state.customer.Customer;
      },
      set(val) {
        if (!val) {
        }
      },
    },
    localeText() {
      return i18nData[this.$i18n.locale];
    },
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
  },
};
</script>
